import { render } from "./tinymce.vue?vue&type=template&id=91b675a0"
import script from "./tinymce.vue?vue&type=script&lang=js"
export * from "./tinymce.vue?vue&type=script&lang=js"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/tinymce.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "91b675a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('91b675a0', __exports__)) {
    console.log('reload')
    api.reload('91b675a0', __exports__)
  }
  
  module.hot.accept("./tinymce.vue?vue&type=template&id=91b675a0", () => {
    console.log('re-render')
    api.rerender('91b675a0', render)
  })

}


export default __exports__